import { Layout as BaseLayout, LayoutProps } from 'react-admin';
import { PageLoading } from 'shared/react-admin/Loading';
import { RequestsBankOpsImportDialogs } from 'shared/widgets/RequestsBankOpsImport/RequestsBankOpsImportDialogs';

import { AppBar } from './components/AppBar/AppBar';
import { Menu } from './components/Menu/Menu';
import { useCheckAuth } from './hooks/useCheckAuth';
import { useLoadUser } from './hooks/useLoadUser';
import { usePageTitle } from './hooks/usePageTitle';
import { usePermissionRedirect } from './hooks/usePermissionRedirect';

export const Layout: React.FC<LayoutProps> = (props) => {
  usePageTitle();
  const { isUserLoaded } = useLoadUser();
  usePermissionRedirect();
  useCheckAuth();

  if (!isUserLoaded) {
    return <PageLoading />;
  }
  return (
    <>
      <BaseLayout {...props} appBar={AppBar} menu={Menu} />
      <RequestsBankOpsImportDialogs />
    </>
  );
};
